import { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { formatDate, IconButton, SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, decodeData, filterModules, formatDateWithTime } from "../../Constants/constants";
import * as XLSX from 'xlsx';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LazyImage from "../../Components/LazyImage";


class HelpAndSupport extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      reporting_manager: '1',
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      loadingSearch: false,
      filterLoading: false,
      loadingLogs: false,
      postLoading: false,
      get_location_row: [],
      goals_rows: [],
      department_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      empOptions: [],
      emp_keyword: '',
      selected_rm_employee_id: '',
      reporting_manager_employee_id: '',
      assignGoalsModal: false,
      goal_id:"",
      goal_title:"",
      goal_description:"",
      from_date: '',
      to_date: '',
      pms_cycle_start_date: '',
      pms_cycle_end_date: '',
      pms_cycle_from_date: '',
      pms_cycle_to_date: '',
      errors: '',
      goal_assign_id: "",
      goal_rating_employee: "",
      ticket_description: "",
     
      goal_status: "",
      sendGoalModal:false,
      viewEmployeeGoalsLogs:false,
    //   employeeGoalsRows: [],
      // modulesOptions: [
      //   {value: "1", label: "Resolved"},
      //   {value: "2", label: "On Hold"},
      //   {value: "3", label: "Close"},
      // ],
      modulesOptions: [],
      action_type: "",
      expense_date: "",
      expense_amount: "",
      formData: {
        file: null,
        fileData: null
      },
      viewDocument:false,
      fileView:false,
      ticketRows: [],
      viewTicketLogs:false,
      decodedData: [],
      editorContent:"",
      query_status: "",
      query_category: "",
      query_status: "",
      query_category: "",
    };
    this.debounceTimerRef = null;
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
    //   this.GetDepartmentMasters();
    //   this.GetEmployeesOptionList();
    //   this.GetLocationMasters();
      this.GetList();
      this.getHeaderList();

    //   this.getHeaderList();
    //   this.GetLocationList();
    });
  }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
            console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                console.log("encodedData",encodedData);
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                console.log("decodedData",decodedData);
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
                }
            } else {
                console.warn("Permissions not yet available. Retrying...");
            }
        }
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios
          .get(`${apiURL}Masters/GetAllQueries`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                query_status: this.state.query_status,
                query_category: this.state.query_category,
            },
            headers,
          })
          .then((response) => {
            var data = response.data;
            if (response.data.success === true) {
              this.setState({
                rows: data.data,
                next: data.next,
                prev: data.prev,
                page: data.page,
                total_records: data.total_records,
                total_pages: data.total_pages,
                loadingList: false,
                filterLoading:false,
              });
            } else {
              this.setState({ loadingList: false,loadingSearch:false, filterLoading:false   });
            }
          }).catch((error)=>{
            console.log(error);
            this.setState({ loadingList: false, loadingSearch:false, filterLoading:false  })
          });
    };

  GetEmployeesOptionList = () => {
    if (this.state.emp_keyword) {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}ExpenseRouter/GetEmployeesOptionList`, { params: { keyword: this.state.emp_keyword }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ empOptions: response.data.data })
            } else {
              this.setState({ empOptions: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }
    } else {
      console.log("no emp keyword")
    }
  }
  GetTicketLogList = (row) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Masters/GetQueriesLogs`, {
        params: {
            query_id : row?.query_id || "",
            employee_id : row?.query_raised_by || "",
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {           
          this.setState({
            ticketRows: data?.data,
            viewTicketLogs:true,
          });
        } else {
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }
      })
      .catch((error)=>{
        console.log(error);
        Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: 'Opps...! Something went wrong.', 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
      })
      .finally(this.setState({ loadingList: false, loadingLogs:false }));
      
  };
  getHeaderList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      axios
        .get(`${apiURL}User/GetEmployeeModuleHierarchy`, {headers,})
        .then((response) => {
          let data = response.data;
          console.log("data",data);
          if (response.data.success === true) {
            const modules= data?.result?.length>0 && filterModules(data?.result);
            // console.log("GetEmployeeModuleHierarchy ~ modules",modules);
            modules.unshift({value:"Suggestion", label:"Suggestion"})
            this.setState({
                modulesOptions: modules
            })
          } else {
            console.error("Error fetching list");
          }
        })
        .catch(function (error) {
          console.log("error", error);
        });
    };

  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    let errors = {};
    console.log(file);
    if (file) {
        const { name, size, type } = file;
        const fileSizeInMB = size / (1024 * 1024);
        console.log("size", fileSizeInMB);
        errors.required_document = '';
        if (fileSizeInMB > 10) {
            errors.file = "File size exceeds the maximum limit of 10 MB";
            this.setState({ errors });
            console.error("File size exceeds the maximum limit of 10 MB");
            return;
        }
        let newState = {
            fileName: name,
            fileSize: `${fileSizeInMB.toFixed(2)} MB`,
            letterhead: [file],
            errorMessage: errors?.file,
            fileDelete: true
        };

        if (type.startsWith("image/")) {
            newState = {
                ...newState,
                selectedImage: URL.createObjectURL(file),
                fileTypeIcon: "/img/img-logo.png",
            };
        } else {
            newState = {
                ...newState,
                isValidPdfFile: true,
                fileTypeIcon: "/img/pdf-logo.svg",
            };
        }
        console.log(file, newState);
        this.setState({
            errors: { ...errors, file: "" },
            formData: {
                ...this.state.formData,
                file: file,
                fileData: newState
            }
        });
    }
};

handleCheckAttachment=(type)=>{
    if (type.includes(".pdf")) {
      return "/img/pdf-logo.svg"
    } else {
        return "/img/img-logo.png"
    }
 }

handleDeleteImage = () => {
    this.setState({
        formData: {
            ...this.state.formData,
            file: null,
            fileData: null
        }
    });
};

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            department_row: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}ExpenseRouter/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  

//    getHeaderList = () => {
//     const { apiURL, apiHeaderJSON } = this.context;
//       const headers = apiHeaderJSON;
//       axios
//         .get(`${apiURL}Employees/GetHeaderPermissionList`, {headers,})
//         .then((response) => {
//           let data = response.data;
//           // console.log(data);
//           if (response.data.success === true) {
//             const modules= data?.result?.length>0 && filterModules(data?.result);
//             console.log("GetEmployeeModuleHierarchy ~ modules",modules);
//             this.setState({
//                 modulesOptions: modules
//             })
//           } else {
//             console.error("Error fetching list");
//           }
//         })
//         .catch(function (error) {
//           console.log("error", error);
//         });
//     };

  handleSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const errors = this.validateForm();
    console.log("SubmitMyGoalReview ERROR:",errors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors,postLoading:false });
      return;
    }
    const formData = {
        query_id: this.state.raiseModal?.query_id || "",
        employee_id: this.state.raiseModal?.query_raised_by,
        action_type : this.state.action_type,
        remarks: this.state.ticket_description,
        date: currentDateAndTime(),
    };
    this.setState({postLoading:true});
    axios.post(`${apiURL}Masters/QueryAction`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            postLoading:false,
            action_type:'',
            raiseModal:false,
            ticket_description: "",
            editorContent: "",
            formData: null,

           
         }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        this.setState({postLoading:false, })
      }
    }).catch((error)=>{
        this.setState({postLoading:false})
        console.log("ERROR",error);
        Swal.fire({ 
            title: `<strong>Failed</strong>`, 
            text: 'Opps...! Something went wrong.', 
            icon: 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });
    });
  };

    validateForm = () => {
        const errors = {};
        if (!this.state.ticket_description) errors.ticket_description = 'Response is required!';    
        if (!this.state.action_type) {
          errors.action_type = 'Please Select Status!';
        }
        // if (!this.state.expense_date) {
        //   errors.expense_date = 'Date is required';
        // }
        // if (this.state.expense_date && this.state.expense_date > currentDateAndTime() ) {
        //   errors.expense_date = 'Expense date cannot be greater than current date!';
        // }
        // if (!this.state.expense_amount) {
        //   errors.expense_amount = 'Amount is required';
        // }
        return errors;
      };

  getInfo=(row)=>{
    let newState = {
        fileName: row?.expense_attachments,
        fileSize: "",
        fileDelete:false,
    };

    if (row?.expense_attachments && row?.expense_attachments.includes("pdf")) {
        newState = {
            ...newState,
            isValidPdfFile: true,
            fileTypeIcon: "/img/pdf-logo.svg",
        };
    } else {
        newState = {
            ...newState,
            // selectedImage: URL.createObjectURL(file),
            fileTypeIcon: "/img/img-logo.png",
        };
    }
    this.setState({
        action_type: row?.action_type,
        expense_date: row?.expense_date,
        expense_amount: row?.expense_amount,
        ticket_description: row?.ticket_description || '',
        formData:{
            file: row?.document_url,
            fileData: newState
        },
        raiseModal: true,
        fileView: true
    }, ()=>{
        console.log(this.state.formData);
    });
  }
    handleCancel = (row) => {    
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON
    // setLoading(true);
    Swal.fire({
        title: 'Are you sure?',
        text: "You want to cancel this?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
        input: 'text', 
        inputPlaceholder: 'Enter your remark here...',
        inputAttributes: {
            'aria-label': 'Enter your remark here...', 
        },
        allowOutsideClick:false,
        preConfirm: (remark) => {
            if (!remark) {
                Swal.showValidationMessage('Remark cannot be empty');
            }
            return remark;
        }
    }).then((result) => {
        if (result.isConfirmed && result.value) {
            const data = {
                action_type:row?.action_type,
                remarks: result.value,
                date: currentDateAndTime()
            }
            axios
            .post(`${apiURL}ExpenseRouter/CancelMyExpense`, data, {
                headers
            })
            .then(response => {
                const { success } = response.data
                if (success === true) {
                
                this.GetList();
                } 
                console.log("response.data ====>",response.data)
                Swal.fire({
                    title: `<strong>${ response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                    
                })
            })
            .catch(error => {
                Swal.fire({
                title: `<strong>"Failed"</strong>`,
                text: error?.data?.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
                })
            })
        }
    });
  
  }

// handleCancel = (row) => {    
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;

//     Swal.fire({
//         title: 'Are you sure?',
//         text: "You want to cancel this?",
//         icon: 'warning',
//         showCancelButton: true,
//         confirmButtonText: 'Yes!',
//         cancelButtonText: 'No!',
//         input: 'text', 
//         inputPlaceholder: 'Enter your remark here...',
//         inputAttributes: {
//             'aria-label': 'Enter your remark here...', 
//         },
//         allowOutsideClick: false,
//         preConfirm: (remark) => {
//             if (!remark) {
//                 Swal.showValidationMessage('Remark cannot be empty');
//             }
//             return remark;
//         }
//     }).then((result) => {
//         if (result.isConfirmed && result.value) {
//             const data = {
//                 action_type: row?.action_type,
//                 remarks: result.value,
//                 date: currentDateAndTime()
//             };

//             axios.post(`${apiURL}ExpenseRouter/CancelMyExpense`, data, { headers })
//                 .then(response => {
//                     console.log("API Response ====>", response.data);
                    
//                     if (response.data.success) { 
//                         this.GetList(); // Ensure this function doesn't throw an error
//                         Swal.fire({
//                             title: '<strong>Success</strong>',
//                             text: response.data.message,
//                             icon: 'success',
//                             timerProgressBar: true,
//                             showConfirmButton: false,
//                         });
//                     } else {
//                         Swal.fire({
//                             title: '<strong>Failed</strong>',
//                             text: response.data.message || "Something went wrong!",
//                             icon: 'error',
//                             showConfirmButton: true,
//                             allowOutsideClick: false
//                         });
//                     }
//                 })
//                 .catch(error => {
//                     console.error("API Error ====>", error); // Log full error
//                     Swal.fire({
//                         title: '<strong>Failed</strong>',
//                         text: error.response?.data?.message || "An error occurred. Please try again.",
//                         icon: 'error',
//                         showConfirmButton: true,
//                         allowOutsideClick: false
//                     });
//                 });
//         }
//     });
// };

  handleRating=(row)=>{
    this.setState({
        goal_id: row?.goal_id,
        goal_assign_id: row?.goal_assign_id,
        goal_title: row?.goal_title || "",
        pms_cycle_start_date: row?.cycle_from_date? formatDate(row?.cycle_from_date): '',
        pms_cycle_end_date: row?.cycle_to_date? formatDate(row?.cycle_to_date): '',
        pms_cycle_from_date: row.goal_start_date? formatDate(row.goal_start_date):'',
        pms_cycle_to_date:  row.goal_end_date? formatDate(row.goal_end_date):'',
        sendGoalModal:true,
        goal_rating_employee: row?.goal_rating_employee || '',
        ticket_description: row?.ticket_description || '',
    });
  }

  handleInputSearch = (e) => {
    this.GetList();
    //   this.GetLocationList();
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }),()=>{
        if(!value && name==="keyword"){
            this.GetList();
        }
    });
  };


  handleCheckboxChange = (employeeId) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(employeeId)) {
        selectedRows.splice(selectedRows.indexOf(employeeId), 1);
      } else {
        selectedRows.push(employeeId);
      }

      return { selectedRows };
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action,row) => {
    Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to change status to ${action}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
    }).then((result) => {
        if (result.isConfirmed) {
            this.setState({ 
                goal_assign_id: row?.goal_assign_id || "",
                employee_id: row?.employee_id || "",
                goal_status: action==="Started"? "1":"2" },
            ()=> this.handleStatusSubmit());
    }});

  };

  handleStatusSubmit = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const formData = {
        goal_assign_id: this.state.goal_assign_id || "",
        employee_id: this.state.employee_id || "",
        goal_status: this.state.goal_status,
        date: currentDateAndTime(),
    };
    Swal.fire({
        title: 'Please wait...',
        html: 'Processing...',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
    axios.post(`${apiURL}ExpenseRouter/HandleMyGoalStatus`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({ 
            postLoading:false,
            goal_status:'',
         }, (prevState) => {
          this.GetList();
        })
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        } else {
        Swal.fire({ title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`, 
            text: response.data.message, 
            icon: response.data.success === true ? 'success' : 'error', 
            showConfirmButton: true,
            allowOutsideClick:false, 
        });      
        this.setState({postLoading:false, })
      }
    }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(()=>{
            Swal.close();
            this.setState({postLoading:false});
        });
  };

//   GetGoalsLogList = (row) => {
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;
//     axios
//       .get(`${apiURL}ExpenseRouter/GetAssignedGoalsLogs`, {
//         params: {
//             goal_assign_id: row?.goal_assign_id || "",
//             employee_id: row?.employee_id || "",
//             is_employee: "1",
//         },
//         headers,
//       })
//       .then((response) => {
//         var data = response.data;
//         if (response.data.success === true) {           
//           this.setState({
//             employeeGoalsRows: data?.data,
//             viewEmployeeGoalsLogs:true,
//           });
//         } else {
//             Swal.fire({ 
//                 title: `<strong>Failed</strong>`, 
//                 text: 'Opps...! Something went wrong.', 
//                 icon: 'error', 
//                 showConfirmButton: true,
//                 allowOutsideClick:false, 
//             });
//         }
//       })
//       .catch((error)=>{
//         console.log(error);
//         Swal.fire({ 
//             title: `<strong>Failed</strong>`, 
//             text: 'Opps...! Something went wrong.', 
//             icon: 'error', 
//             showConfirmButton: true,
//             allowOutsideClick:false, 
//         });
//       })
//       .finally(this.setState({ loadingList: false, loadingLogs:false }));
      
//   };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            get_location_row: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title
            }))
          }));
        }
      });
  }

  handleExcelDownload = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    Swal.fire({
        title: 'Please wait...',
        html: 'Your file is being prepared for download.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    axios.get(`${apiURL}ExpenseRouter/GetMyGoalsList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },headers
    }).then(async (response) => {
        // console.log("handleExcelDownload",response);
        if (response.data?.success === true) {
            const rows = response.data?.data;
            const data = rows.map(row => ({
                'Employee Code': row?.employee_code ? row?.employee_code : "-",
                'Employee Name': row?.employee_name ? row?.employee_name : "-",
                'Reporting Manager': row?.reporting_manager_name ? row?.reporting_manager_name : "-",
                'Assigned Date': row?.assigned_date? formatDate(row?.assigned_date):"--",
                'PMS Cycle': `${row?.cycle_from_date? formatDate(row?.cycle_from_date):""} To ${row?.cycle_to_date? formatDate(row?.cycle_to_date):""}`,
                'Goal Start Date': ` ${row?.goal_start_date ? formatDate(row?.goal_start_date) : "-"}`,
                'Goal End Date': `${row?.goal_end_date ? formatDate(row?.goal_end_date) : "-"}`,
                'Task Submitted Date': `${row?.goal_submitted_date ? formatDate(row?.goal_submitted_date) : "-"}`,
                'Goal Title': row?.goal_title ? row?.goal_title : "-",
                // 'Department': row?.department_title ? row?.department_title : "-",
                // 'Location': row?.location_title ? row?.location_title : "-",
                'Status': row?.GoalStatus ? row?.GoalStatus : "-",
                'Employee Rating': row?.goal_rating_employee ? row?.goal_rating_employee : "-",
                'RM Rating': row?.goal_rating_rm ? row?.goal_rating_rm : "-",
                'Grade': row?.goal_grade ? row?.goal_grade : "-",
                'Remark By Employee': row?.ticket_description ? row?.ticket_description : "-",
                'Remark By RM': row?.goal_rating_remarks_rm ? row?.goal_rating_remarks_rm : "-",
            }));

            const columns = [
                { header:  'Employee Code', key:  'Employee Code', width: 20 },
                { header:  'Employee Name', key:  'Employee Name', width: 20 },
                { header: 'Reporting Manager', key: 'Reporting Manager', width: 20 },
                { header: 'Assigned Date', key: 'Assigned Date', width: 20 },
                { header: 'PMS Cycle', key: 'PMS Cycle', width: 20 },
                { header: 'Goal Start Date', key: 'Goal Start Date', width: 20 },
                { header: 'Goal End Date', key: 'Goal End Date', width: 20 },
                { header: 'Task Submitted Date', key: 'Task Submitted Date', width: 20 },
                { header: 'Goal Title', key: 'Goal Title', width: 20 },
                // { header: 'Department', key: 'Department', width: 20 },
                // { header: 'Location', key: 'Location', width: 20 },
                { header: 'Status', key: 'Status', width: 20 },
                { header: 'Employee Rating', key: 'Employee Rating', width: 20 },
                { header: 'RM Rating', key: 'RM Rating', width: 20 },
                { header: 'Grade', key: 'Grade', width: 20 },
                { header: 'Remark By Employee', key: 'Remark By Employee', width: 20 },
                { header: 'Remark By RM', key: 'Remark By RM', width: 20 },
            ];

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });
            ws['!cols'] = columns.map(column => ({ wch: column.width }));
            XLSX.utils.book_append_sheet(wb, ws, 'My Goals Report');

            // XLSX.writeFile(wb, `AbStartMyAttendanceReport_(${Date()}).xlsx`);
            const date=currentDateAndTime();
            XLSX.writeFile(wb, `My Goals Report ${formatDate(date)}.xlsx`);

            Swal.close();

            Swal.fire({
                title: '<strong>Success</strong>',
                html: 'Your file has been downloaded successfully.',
                icon: 'success'
            });
        } else {
            Swal.close();
            Swal.fire({
                title: '<strong>Error</strong>',
                html: response.data.message,
                icon: 'error'
            });
        }
    }).catch((error) => {
        Swal.close();
        Swal.fire({
            title: '<strong>Error</strong>',
            html: error.message,
            icon: 'error'
        });
    });
}

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
            if(this.state.rows?.length>0){
                this.GetList();
            }
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };

  handleEditorChange = (content) => {
    this.setState({ editorContent: content });

    if (this.debounceTimerRef) {
      clearTimeout(this.debounceTimerRef);
    }

    this.debounceTimerRef = setTimeout(() => {
        this.setState({
            ticket_description: content
          }, ()=>{ console.log('ticket_description',this.state.ticket_description) })
    }, 1000);
  };

  handleSelectChange = (name, selectedOption) => {

    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        if(this.state.rows?.length>0){
            this.GetList();
        }
      }
    );
  };
  
  handleClearAll = () => {
    this.setState(
      {
        from_date: "",
        to_date: "",
        query_status: "",
        query_category: "",
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500,];
    const ticketStatus= [
        {value: "0", label: "Open"},
        {value: "1", label: "Resolved"},
        {value: "2", label: "On Hold"},
        {value: "3", label: "Close"},
      ];
    const { errors } = this.state;
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Help & Support`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                       <div className='col-md-3'>
                            <TextBox type="Date" id="from_date" name="from_date" label="From Date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-3'>
                            <TextBox type="Date" id="to_date" name="to_date" label="To Date" value={this.state.to_date} change={this.handleInputChange} />
                        </div>
                        <div className="col-md-3">
                          <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                              <label>Ticket Status</label>
                              <Select onChange={(selectedOption) => this.handleSelectChange("query_status", selectedOption )}
                              placeholder={`All`}
                              options={ticketStatus}
                              value={
                                this.state.query_status
                                ? ticketStatus.find(
                                    (option) =>
                                        option.value == this.state.query_status
                                    )
                                : null
                              }
                              />
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                              <label>Ticket Module</label>
                              <Select onChange={(selectedOption) => this.handleSelectChange("query_category", selectedOption )}
                              placeholder={`All`}
                              options={this.state.modulesOptions}
                              value={
                                this.state.query_category
                                ? this.state.modulesOptions.find(
                                    (option) =>
                                        option.value == this.state.query_category
                                    )
                                : null
                              }
                              />
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                          <label>Ticket Module</label>
                          <Select onChange={(selectedOption) => this.handleSelectChange("query_category", selectedOption )}
                          placeholder={`All`}
                          options={this.state.modulesOptions}
                          value={
                          this.state.query_category
                          ? this.state.modulesOptions.find(
                          (option) =>
                          option.value == this.state.query_category
                          )
                          : null
                          }
                          />
                        </div>
                                                </div>
                        <div className='col-md-3'>
                            <div className=" d-flex align-items-center gap-2">
                                <div className='col-md-6'>
                                <div>
                                    <label>Apply Filter</label>
                                </div>
                                <SubmitButton otherClasses='w-100' onClick={()=>{
                                  if(!this.state.filterLoading){
                                    this.setState({
                                      filterLoading:'1'
                                    },()=> this.handleInputSearch())
                                    
                                  } }} disabled={(!this.state.from_date && !this.state.to_date && !this.state.query_status && !this.state.query_category) || this.state.filterLoading==='2'}
                                loading={this.state.filterLoading==='1'}
                                buttonName={"Filter"} loadingMessage='Loading' type='info' icon='ri-filter-3-fill' />
                                </div>
                                <div className='col-md-6'>
                                <div>
                                    <label className="noWrap">Clear Filter</label>
                                </div>
                                    <SubmitButton otherClasses='w-100' onClick={()=>{
                                  if(!this.state.filterLoading){
                                    this.setState({
                                      filterLoading:'2'
                                    },()=> this.handleClearAll())
                                  } }} disabled={(!this.state.from_date && !this.state.to_date && !this.state.query_status && !this.state.query_category) || this.state.filterLoading==='1'}
                                    loading={this.state.filterLoading==='2'}
                                    buttonName={"Clear"} loadingMessage='Loading' type='secondary' icon='ri-database-2-line' />
                                </div>
                            </div>
                        </div>
                        {/* { this.state.decodedData?.includes(2) && ( 
                        <div className='col-md-3'>
                            <div>
                                <label>Support Ticket</label>
                            </div>
                            <SubmitButton onClick={()=> this.setState({  raiseModal:true, fileView:false, ticket_description:'', })}
                            buttonName={ "Apply"} loadingMessage='Loading' type='secondary' icon='ri-add-box-line' />
                        </div>)} */}
                        {/* <div className='col-md-3'>
                            <div className=" d-flex align-items-center gap-2">
                                <div className='col-md-6'>
                                    <div>
                                        <label>Export Excel</label>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={this.handleExcelDownload}
                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-success btn-label waves-effect waves-light noWrap`}>
                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                        Export Excel
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div>
                        <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                            <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                <tr>
                                <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                                <th style={{ width:"10%"}} className="noWrap text-center">Ticket Date</th>
                                <th>Company Name</th> 
                                <th>Module</th>
                                <th className="noWrap">Ticket Send By</th>
                                <th style={{ width:"10%"}}>Status</th>
                                { (this.state.decodedData?.includes(1)||this.state.decodedData?.includes(3)) && ( 
                                <th  style={{ width:"10%"}} className="text-center">Action</th>)}
                                </tr>
                            </thead>
                            {this.state.rows.length === 0 ? (
                                <tbody>
                                <tr>
                                    <td colSpan={11}>
                                    <NoRecords />
                                    </td>
                                </tr>
                                </tbody>
                            ) :
                            <tbody>
                            {this.state.rows.map((row,idx) => {
                                return (
                                    <tr key={row?.goal_id}>
                                        <td className="text-center">{idx+1}</td>
                                        <td className="noWrap">{row.created_date? formatDate(row.created_date):"--"}</td>
                                        <td >{row?.legal_entity_name? row?.legal_entity_name :"--"}</td>
                                        <td>{row?.header_name || row?.suggestion_query || "--"}</td> 
                                        {/* <td>
                                            <div className=' text-truncate'
                                            style={{
                                                maxHeight: "50px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "-webkit-box",
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: "vertical",
                                              }}
                                            dangerouslySetInnerHTML={{ __html: row?.query_description ? row?.query_description : "", }}/>
                                        </td>  */}
                                        <td>{`${row?.employee_name} (${row?.employee_code})`|| "--"}</td> 
                                        <td>
                                            <div
                                                style={{ fontSize: "0.65rem" }}
                                                className={`noWrap bg-${row?.QueryStatusClasses} text-white fw-semibold px-1 text-center py-1  rounded-4`}
                                            >
                                                {row?.QueryStatus}
                                            </div>
                                        </td> 
                                        { (this.state.decodedData?.includes(1)||this.state.decodedData?.includes(3))&& ( 
                                        <td>
                                            <div className="d-flex justify-content-around gap-2">
                                            { this.state.decodedData?.includes(1) && ( 
                                                <IconButton 
                                                loading={this.state.loadingLogs}
                                                onClick={() => {
                                                    if(!this.state.loadingLogs){
                                                        this.setState({loadingLogs:true},
                                                            ()=>this.GetTicketLogList(row))
                                                    }
                                                }} type='success' icon='ri-file-text-line' tooltipName='View' tooltipPosition='bottom' />)}
                                            { this.state.decodedData?.includes(3) && ( 
                                                <IconButton 
                                                // loading={this.state.loadingLogs}
                                                disabled={row?.QueryStatus==="Resolved"}
                                                onClick={() => {
                                                    this.setState({ raiseModal:row })
                                                }} type='primary' icon='ri-send-plane-fill' tooltipName={row?.QueryStatus==="Resolved"? '':'Reply'} tooltipPosition='bottom' />)}

                                                {/* { this.state.decodedData?.includes(3) && ( 
                                                     <IconButton 
                                                     loading={this.state.loadingLogs}
                                                     onClick={() => {
                                                         if(!this.state.loadingLogs){
                                                             this.setState({loadingLogs:true},
                                                                 ()=>this.GetTicketLogList(row))
                                                         }
                                                     }} type='danger' icon='ri-chat-delete-line' tooltipName='Cancel' tooltipPosition='bottom' />
                                                <TooltipComponent name="Cancel" position="bottom">
                                                    <button
                                                        onClick={() =>{
                                                            this.handleCancel(row);
                                                        }}
                                                        disabled={row?.ExpensesStatus!=="Applied"}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-danger mr-2 text-center"
                                                        > 
                                                        <i className="ri-chat-delete-line"></i>
                                                    </button>
                                                </TooltipComponent>
                                            )}                                                */}
                                                {/* <TooltipComponent name="Send For Review" position="bottom-left">
                                                    <button
                                                        onClick={() =>{
                                                            this.handleRating(row)
                                                        }}
                                                        type="button"
                                                        className="btn-icon btn btn-sm btn-outline-primary mr-2 text-center"
                                                        > 
                                                        <i className="ri-send-plane-fill"></i>
                                                    </button>
                                                </TooltipComponent> */}
                                            </div>
                                        </td>)}
                                    </tr>
                                );
                            })}
                            </tbody>}
                        </table>
                    </div>
                    <div className="d-flex justify-content-between bg-light align-items-center w-100 py-2 px-2" >
                        <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                        <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                            {
                                <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                            }
                        </div>
                        <div className='col-md-2'>
                            <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                {Array.from({ length: this.state.total_pages }, (_, i) => (
                                    <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                {this.state.rows?.length>0 && (
                                    <option value={this.state.rows?.length}>
                                    All
                                    </option>
                                )}
                                {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                        Limit {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                    </div>
                  </div>
                </div>
                {this.state.raiseModal && (
                    <div className="modal show" 
                        style={{
                            display: "block",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }} >
                        <div className="modal-dialog modal-xl"
                        style={{ width: "60%" }}
                        >
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalgridLabel">Response Ticket</h5>
                                <button type="button"
                                disabled={this.state.postLoading} className="btn-close" onClick={()=>{
                                    this.setState({
                                        action_type :'',
                                        raiseModal:false,
                                        fileView:false,
                                        expense_date: "",
                                        expense_amount: "",
                                        ticket_description: "",
                                        editorContent: "",
                                       expense_attachment: "",
                                       
                                    })
                                }} aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <div className="container mt-2">
                                <form className="row">  
                                    <div className="col-md-6 mt-3">
                                        <label className="form-label">Ticket Status:</label>
                                            <Select
                                                options={ticketStatus}
                                                value={ this.state.action_type ? ticketStatus.find(option => option.value == this.state.action_type) : null }
                                                onChange={(selectOption) => this.setState({ action_type: selectOption?.value, errors: { ...errors, action_type:"" } })}
                                                placeholder={`Select Status`}
                                            />
                                            {this.state.errors.action_type && <div className="text-danger">{this.state.errors.action_type}</div>}
                                    </div>    
                                    <div className="col-md-6 mt-3">
                                        <label className="form-label">Ticket Date:</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="created_date"
                                            name="created_date"
                                            disabled
                                            value={formatDate(currentDateAndTime()?.split(" ")[0]) || "--"}
                                        />
                                    </div>                                              
                                    <div className='col-md-12 mb-3 mt-3'>             
                                        <label htmlFor="ticket_description" className="form-label">Response:</label>
                                        <ReactQuill
                                        value={this.state.editorContent}
                                        onChange={this.handleEditorChange}
                                        placeholder="Write your response..."
                                        theme="snow"
                                        />
                                        {this.state.errors.ticket_description && <div className="text-danger">{this.state.errors.ticket_description}</div>}
                                    </div>
                                </form>
                                {!this.state.fileView && (
                                    <div className="col-md-12 mt-3 mb-3 d-flex justify-content-end align-items-center gap-3" >
                                        <SubmitButton onClick={this.handleSubmit} loading={this.state.postLoading}
                                        buttonName={"Reply"} loadingMessage='Loading' type='primary' icon='ri-send-plane-fill' />
                                        
                                        <SubmitButton disabled={this.state.postLoading} 
                                        onClick={()=>{
                                             this.setState({
                                                action_type :'',
                                                raiseModal:false,
                                                fileView:false,
                                                expense_date: "",
                                                expense_amount: "",
                                                ticket_description: "",
                                                editorContent: "",
                                                expense_attachment: "",
                                            })
                                        }}
                                        buttonName="Cancel" type='secondary' icon='ri-close-line' /> 
                                </div>
                                )}
                                
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.viewTicketLogs && (
                     <div className="modal show" 
                     style={{
                         display: "block",
                         backgroundColor: "rgba(0, 0, 0, 0.5)",
                     }}  >
                        <div className="modal-dialog modal-xl"
                            style={{ width: "75%" }}>
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="rmModalLabel">Ticket Raised History</h5>
                                <button type="button" className="btn-close" onClick={()=> this.setState({ viewTicketLogs:false, })} aria-label="Close" />
                            </div>
                            <div className="mx-4 mt-2 border-bottom border-2 border-light mb-2 d-flex justify-content-between align-items-center p-1">
                            <h6 className="mb-0"><span className="text-muted mb-0">Module Name: </span>{this.state.ticketRows[0]?.header_name || this.state.ticketRows[0]?.suggestion_query || "--"}</h6>
                            <h6 className="mb-0">{this.state.ticketRows[0]?.legal_entity_name || "--"}</h6>
                          </div>

                        <div style={{ "maxHeight": "82vh", "overflowY": "auto", "overflowX": "auto" }}>
                          <div className="modal-body pt-1">
                              { Array.isArray(this.state.ticketRows) && this.state.ticketRows?.length>0 ?
                              this.state.ticketRows?.map((row,idx)=>{
                                  return(
                                    <> 
                                      {/* <label className="form-label">{row?.action_by_type=="1"? 'Replied ':'Ticket '}Date-Time: {row?.created_date ? formatDateWithTime(row?.created_date) : "--"}</label> */}
                                      {/* bg-opacity-10 ${row?.action_by_type=="1" ? 'bg-success-subtle':'bg-body-tertiary'}  */}
                                      <form className={`row border border-2 border-light rounded-3 bg-light.bg-gradient mx-3 mb-3 `}>
                                          {/* <div className="col-md-4 mt-3">
                                              <label className="form-label">Module Name:</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="header_name"
                                                    name="header_name"
                                                    value={row?.header_name || row?.suggestion_query || "--"}
                                                />
                                          </div>                                                  */}
                                          {/* <div className="col-md-4 mt-3">
                                              <label className="form-label">{row?.action_by_type=="1"? 'Replied ':'Action '}By:</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="action_by"
                                                    name="action_by"
                                                    value={row?.action_by || "--"}
                                                />
                                          </div> */}
                                          {/* /img/fav-round-corner.png */}
                                          <div className="d-flex justify-content-between align-items-center mt-2">
                                            <div className="d-flex gap-1 align-items-center col-md-4">
                                                  {/* <small className=" text-muted">{row?.action_by_type=="1"? 'Replied ':'Action '}By:</small> */}
                                                  <button
                                                    type="button"
                                                    className="btn p-1 bg-light rounded-circle"
                                                  >
                                                    <span className="d-flex align-items-center">
                                                      <LazyImage src={`${row?.action_by_type=="1" ? "assets/images/fav-round-corner.png" : row?.action_by_profile_url || "assets/profile-pic.png"}`} 
                                                      alt="Company_logo" className="rounded-circle header-profile-user" />
                                                    </span>
                                                  </button>
                                                  <h6 className=" mb-0">{row?.action_by_type=="1" ? "ABStart Support" : row?.action_by || "--"}</h6>
                                                  <div
                                                      style={{ fontSize: "0.65rem" }}
                                                      className={`noWrap bg-${row?.QueryStatusClasses} text-white fw-semibold px-1 text-center px-3 py-1 rounded-2`}
                                                  >
                                                      {row?.QueryStatus}
                                                  </div>
                                            </div>    
                                            <small className=" text-muted mb-0">{row?.created_date ? formatDateWithTime(row?.created_date) : "--"}</small>                                               
                                            {/* <div className="col-md-4 mt-3">
                                                <label className="form-label">{row?.query_resloved_remarks? 'Replied ':'Ticket '}Date-Time:</label>
                                                  <input
                                                      type="text"
                                                      className={`form-control`}
                                                      id="created_date"
                                                      name="created_date"
                                                      value={row?.created_date ? formatDateWithTime(row?.created_date) : "--"}
                                                  />
                                            </div> */}
                                          </div> 
                                          <div style={{width:"95%"}} className=" border-bottom border-2 border-light mt-2 m-auto"></div>
                                          <div className='col-md-12 mb-3 mt-1'>             
                                              {/* <label htmlFor="ticket_description" className="form-label">{row?.query_resloved_remarks? 'Replied Response':'Ticket Description'}:</label> */}
                                              <div style={{ minHeight:"5rem" }} className='card-body rounded-3 py-2 bg-white text-black-50'
                                              dangerouslySetInnerHTML={{ __html: row?.query_resloved_remarks ? row?.query_resloved_remarks :  row?.query_description ? row?.query_description : "--", }}/>
                                          </div>
                                          {/* <div className=" w-100 border-bottom border-2 border-light mt-3"></div> */}
                                          {row?.action_by_type!=="1" && (
                                              row?.query_attechment && row?.query_attechment_url &&(
                                                <div className='col-md-12 mb-3 mt-1'>
                                                  <label className="form-label">Attachment <span className='text-muted '>
                                                      {/* {!formData?.fileData?.fileName && !this.state.fileView ? '(...Optional)': '(Not Attached)'} */}
                                                      </span></label>
                                                  <div>
                                                      <ul className="list-unstyled mb-0 bg-white">
                                                          <li className=" dz-processing dz-error dz-complete">
                                                              <div className="border rounded w-auto">
                                                                  <div className="d-flex p-2 cursorPointer" 
                                                                    onClick={() => {
                                                                        this.setState({ viewDocument: `${idx}`,viewTicketLogs:false, });
                                                                    }}>
                                                                    <div
                                                                        className={` flex-shrink-0 me-3`}
                                                                        
                                                                    >
                                                                        <div className="p-1 bg-light rounded d-flex align-items-center justify-content-center">
                                                                            <img style={{ width: "20px" }} src={this.handleCheckAttachment(row?.query_attechment)} alt="file" />
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <div className="pt-1">
                                                                            <h5 className="fs-13 mb-1">{row?.query_attechment}</h5>
                                                                        </div>
                                                                    </div>
                                                                  </div>
                                                              </div>
                                                          </li>
                                                      </ul>
                                                  </div>
                                              </div> 
                                              )
                                          )} 
                                      </form>
                                    </>
                                      
                                  )
                              }) :
                                  <div>No History Found!</div> }
                          </div>
                        </div>
                            </div>
                        </div>
                     </div>
                )}
                {this.state.viewDocument && (
                    <div id="myModal" className="modal show"
                        tabIndex={-1} style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                    >
                        <div
                        className=" bg-light m-auto mt-3"
                        style={{ width: "75%" }}
                        >
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="myModalLabel">
                                Attachment
                            </h5>
                            <button onClick={() => {
                                this.setState({viewTicketLogs:true, viewDocument:false });
                                }}
                                className="btn-close"
                                aria-label="Close"
                            ></button>
                            </div>
                            <div
                            style={{ padding: "0 10px 10px 0" }}
                            className="modal-body"
                            >
                            <div className="row">
                                <div
                                className="mb-4 m-auto p-1 rounded-2 grayBlurShadow"
                                style={{ width: "80%" }}
                                >
                                {/* <h3 className="text-center">
                                    {this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment || "--"}
                                </h3> */}
                                <div
                                    className="m-auto rounded-3 overflow-hidden"
                                    style={{
                                    width: "100%",
                                    height: `${this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment && this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment?.includes(".pdf") ?
                                      "600px": "auto"}`,
                                    border: "1px solid #ccc",
                                    }}
                                >
                                    {this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment && this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment?.includes(".pdf") ? (
                                    <iframe
                                        src={this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment_url}
                                        title="PDF Viewer"
                                        style={{
                                        width: "100%",
                                        height: "100%",
                                        }}
                                        frameBorder="0"
                                    >
                                        This browser does not support embedded
                                        files.
                                    </iframe>
                                    ) : (
                                    this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment_url?
                                    <img
                                        src={this.state.ticketRows[parseInt(this.state.viewDocument)]?.query_attechment_url}
                                        style={{
                                        width: "100%",
                                        // height: "100%",
                                        }}
                                        alt="document_image"
                                    />:
                                    <p>Attachment Not Found!</p>
                                    )}
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(HelpAndSupport);
